import styled from 'styled-components';

import { ChipDatePickerContainerBase } from './ChipDatePickerContainerBase';
import { getRem } from '../../core';

export const ChipDateRangePickerContainer = styled(ChipDatePickerContainerBase)`
  display: flex;
  max-width: ${getRem(300)};
  position: relative;
`;
